import React, { useState } from "react";
import {
  Paper as PaperMUI,
  Grid,
  Typography,
  Tooltip,
  IconButton,
  ImageListItem,
} from "@mui/material";
import { makeStyles, withStyles } from "@mui/styles";
import Skeleton from "@mui/material/Skeleton";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import PropTypes from "prop-types";

import { deleteFavorite } from "../store/ducks/duckFavorites";

import { useAppInsights } from "./AppInsightsProvider";

const useStyles = makeStyles({
  title: {
    paddingLeft: 20,
    width: 232,
    marginRight: 0,
    marginLeft: 0,
  },
  paper: {
    height: 165,
    margin: 10,
    width: 197,
  },
  linkText: {
    cursor: "pointer",
  },
  gridTitle: {
    height: 30,
  },
});

const TypographyStyled = withStyles((theme) => ({
  subtitle1: {
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
      textDecorationColor: theme.palette.primary,
    },
  },
}))(Typography);

const Image = ({ customId }) => {
  return (
    <img
      key={`Layout-Miniatura-${customId}`}
      alt={`Layout-Miniatura-del-layout-${customId}`}
      height={80}
      src={`${process.env.PUBLIC_URL}/LayoutMiniatura.png`}
      width={150}
    />
  );
};

Image.propTypes = {
  customId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const MemoizedImage = React.memo(Image);

const FavoriteElement = (props, ref) => {
  const { name, id, favoriteId, pathComplete, isSkeleton = false } = props;

  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const [showDelete, setShowDelete] = useState(false);

  const appInsights = useAppInsights();

  const handleHover = () => setShowDelete(true);

  const handleLeave = () => setShowDelete(false);

  const handleDelete = () => {
    dispatch(deleteFavorite(favoriteId));
  };

  const handleRedirect = (id, pathComplete) => (e) => {
    e.preventDefault();
    if (localStorage.getItem("Email") != "") {
      appInsights.setAuthenticatedUserContext(localStorage.getItem("Email"));
      appInsights.trackEvent({
        name: "FavouriteSelection",
        properties: { Path: pathComplete },
      });
    }
    history.push(`/Layout/${id}`);
  };

  const Paper = withStyles({
    root: {
      height: 165,
      margin: 10,
      width: 197,
      backgroundColor: "#fff",
    },
  })(PaperMUI);

  return (
    <ImageListItem key={`GridListTile-${id}`} ref={ref} classes={{ tile: classes.title }} cols={1}>
      <Paper
        key={`Paper-item-Layout-${id}`}
        classes={{ root: classes.paper }}
        elevation={3}
        onMouseEnter={handleHover}
        onMouseLeave={handleLeave}
      >
        <Grid
          container
          justify={"flex-start"}
          spacing={0}
          style={{
            minHeight: "100%",
            padding: "6%",
            textAlign: "center",
          }}
        >
          <Grid item className={classes.gridTitle} xs={11}>
            <Typography noWrap color="textPrimary" component={"span"} variant="subtitle1">
              {isSkeleton ? <Skeleton variant="text" /> : <>{name}</>}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            {!isSkeleton && showDelete && (
              <Tooltip key={"Tooltip-Remove-Favorite-Element"} title={"Remove Favorite"}>
                <IconButton size={"small"} style={{ marginLeft: -20 }} onClick={handleDelete}>
                  <DeleteOutlineIcon />
                </IconButton>
              </Tooltip>
            )}
          </Grid>
          <Grid item xs={12}>
            <MemoizedImage customId={id} />
          </Grid>

          <Grid item xs={12}>
            {isSkeleton ? (
              <Typography component={"span"} variant="caption">
                <Skeleton variant="text" />
              </Typography>
            ) : (
              <Tooltip title={`Go to ${pathComplete}`}>
                <TypographyStyled
                  noWrap
                  classes={{ subtitle1: classes.linkText }}
                  color="textPrimary"
                  variant="subtitle1"
                  onClick={handleRedirect(id, pathComplete)}
                >
                  <>{pathComplete}</>
                </TypographyStyled>
              </Tooltip>
            )}
          </Grid>
        </Grid>
      </Paper>
    </ImageListItem>
  );
};

const FavoriteElementWithRef = React.forwardRef(FavoriteElement);

FavoriteElementWithRef.propTypes = {
  name: PropTypes.string,
  id: PropTypes.any,
  pathComplete: PropTypes.string,
  isSkeleton: PropTypes.bool,
  handleClick: PropTypes.func,
  favoriteId: PropTypes.number,
};

export default React.memo(FavoriteElementWithRef);
